export function getRecipeTypes(item) {
    if (item && item.RecipeTypes && item.RecipeTypes.length) {
        return item.RecipeTypes.filter((tag) => tag && tag.Text);
    }

    if (!item || !item.Tags) {
        return [];
    }

    return item.Tags.filter((tag) => tag && tag.Text && tag.Type && tag.Type.CodeName === 'Types');
}

export function getDairyTypes(item) {
    if (item && item.DairyTypes && item.DairyTypes.length) {
        return item.DairyTypes.filter((tag) => tag && tag.Text);
    }

    return [];
}

export function getCookTime(item) {
    if (!item) {
        return '';
    }

    return item.CookTime || item.TotalTime || '';
}
